exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button__Button {\n  /* background-color: red; */\n  font-size: 25px;\n  width: 100%;\n  height: 64px;\n  border-radius: 32px;\n  color: var(--WHITE);\n  cursor: pointer;\n}\n\n.button__Button:hover {\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px 2px;\n}\n\n.button__Button:focus {\n  outline: none;\n}\n", ""]);

// exports
